import useMutationVariableCreateUpdate from './variable-use-mutation-create-update';
import useMutationVariableDelete from "./variable-use-mutation-delete";
import useMutationVariableGroupDelete from "./variable-use-mutation-group-delete";


export const variableUseMutation = {
  createUpdate: useMutationVariableCreateUpdate,
  delete: useMutationVariableDelete,
  deleteGroup: useMutationVariableGroupDelete
}